import React from "react";
import Tablecomponent from "../../helpers/TableComponent/TableComp";
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import "./TicketTable.css";
import { Input, Select, notification } from "antd";
import axiosInstance from "../../api/axiosInstance";
// import IconsModal from '../ManageService/IconsModal'
import { apiurl, SupportNameFn } from "../../App";
import TicketModal from "./TicketModal";
import TicketView from "./TicketView";
import plus from "../../Images/plus.png";
import TickMark from '../../Images/tickmark.svg';
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import dateformat from "dateformat";


class TicketTable extends React.Component {
  state = {
    open: false,
    openview: false,
    editopen: false,
    getTableData: [],
    tabledata: [],
    props_loading: false,
    editdetails: [],
    fulltabledata: [],
    // editoneTimeOpen:false,
    Search: null,
    deleteopen: false,
    openTicketSuccess: false,
    ticket_no: "",
    open_ticket_view: false,
    ticket_success_msg: ""
  };

  modelopen = (data, id) => {
    if (data === "view") {
      var editdetails = this.state.fulltabledata.filter((data) => {
        return data.ticket_id === id;
      });
      this.setState({ editdetails: editdetails[0], open_ticket_view: true });
    } else if (data === "edit") {
      var editdetails = this.state.fulltabledata.filter((data) => {
        return data.ticket_id === id;
      });
      this.setState({
        editdetails: editdetails[0],
        editopen: true,
        // editoneTimeOpen:true
      });
    }
    else if (data === "reopen") {
      var editdetails = this.state.fulltabledata.filter((data) => {
        return data.ticket_id === id;
      });
      this.setState({ ticket_no: editdetails[0]['ticket_no'] })
      this.ticketStatusChange(editdetails[0]['ticket_no'], 'RO')
    }
    else if (data === "resolved") {
      var editdetails = this.state.fulltabledata.filter((data) => {
        return data.ticket_id === id;
      });
      this.setState({ ticket_no: editdetails[0]['ticket_no'] })
      this.ticketStatusChange(editdetails[0]['ticket_no'], 'RE')
    }
  };

  closemodal = () => {
    this.setState({ editopen: false, deleteopen: false });
  };
  componentDidMount() {
    this.setState({ props_loading: true });
    this.getTableData();

    this.intervalId = setInterval(() => {
      this.setState({ props_loading: true });
      this.getTableData();
    }, 120000);
  }

  componentWillUnmount() {
    // Clear the interval when the component is unmounted to avoid memory leaks
    clearInterval(this.intervalId);
  }

  convertTo12HourFormat = (time24) => {
    if (time24) { // Check if time24 is not null or undefined
      const [hour, minute] = time24.split(":");
      // let period = "am";

      let hour12 = parseInt(hour);

      if (hour12 >= 12) {
        if (hour12 > 12) {
          hour12 -= 12;
        }
        // period = "pm";
      }

      // Ensure the hour is in two-digit format, e.g., "01" instead of "1"
      const hour12Formatted = hour12.toString().padStart(2, "0");

      return `${hour12Formatted}:${minute} `;
    } else {
      // Handle the case where val.booked_time is null or undefined
      return "N/A"; // You can set a default value or handle it accordingly
    }
  }
  getTableData = () => {
    axiosInstance({
      method: "post",
      url: apiurl + "admin/get_vendor_ticket",
      data: {
        vendor_id: Cookies.get("pharmacy_id") ? Cookies.get("pharmacy_id") : 0,
        limit: 1000,
        pageno: 1,
      },
    }).then((response) => {
      var tabledata = [];
      var fulltabledata = [];
      if (response.data.status != 0) {
        response.data.data.map((val, index) => {
          let response = val.comments_arr ? JSON.parse(val.comments_arr)[(JSON.parse(val.comments_arr).length - 1)]['comments'] : ""
          var valid_date_and_time = dateformat(val.ticket_date, "dd-mmm-yy hh:MMtt");
          var dateandtime = valid_date_and_time.split(" ")
          var val_date = dateandtime[0];
          tabledata.push({
            ticket_id: val.ticket_no,
            screen_name: SupportNameFn(val.screen_name),
            status: this.getStatusByCode(val.status),
            date: val_date,
            time: this.convertTo12HourFormat(val.ticket_time
            ),
            //response: val.admin_comments, //<span className="remark_txt"> {response} </span>,
            id: val.ticket_id
          });
          fulltabledata.push(val);
        });
      }

      this.setState({
        tabledata: tabledata,
        fulltabledata: fulltabledata,
        props_loading: false,
      });

    });
  };

  getStatusByCode = (data) => {
    switch (data) {
      case "P":
        return "Pending"
      case "RO":
        return "Reopened"
      case "C":
        return "Closed"
      case "RE":
        return "Resolved"
      default:
        return ""
    }
  }

  handleClickopen = () => {
    this.setState({ open: true });
  };
  handleClickclose = () => {
    this.setState({ open: false });
  };

  ticketSuccess = (ticket_no) => {
    const { t } = this.props;
    const ticket_raised_successfully = t("ticket_raised_successfully");
    // this.setState({ open: false, openTicketSuccess: true, ticket_no: ticket_no, ticket_success_msg: 'Ticket raised successfully!' });
    this.setState({ open: false, openTicketSuccess: true, ticket_no: ticket_no, ticket_success_msg: ticket_raised_successfully });
  }

  handleCloseSuccess = () => {
    this.setState({ openTicketSuccess: false, props_loading: true }, () => {
      this.getTableData()
    })
  }

  handleTicketViewClose = () => {
    this.setState({ open_ticket_view: false });
  }

  ticketStatusChange = (id, status) => {
    axiosInstance({
      method: "post",
      url: apiurl + "admin/update_ticket_status",
      data: {
        ticketId: id,
        status: status,
        module_name: "Pharmacy",
      },
    }).then((response) => {

      const { t } = this.props;
      const your_ticket_reopened = t("your_ticket_reopened");
      const your_ticket_resolved = t("your_ticket_resolved");
      if (response.data.data[0]['ErrorCode'] == "9999") {
        // this.setState({ open: false, openTicketSuccess: true, ticket_no: this.state.ticket_no,
        //    ticket_success_msg: (status == 'RO' ? 'Your ticket reopened successfully!' :
        //     'Your ticket resolved successfully!') });
        this.setState({
          open: false, openTicketSuccess: true, ticket_no: this.state.ticket_no,
          ticket_success_msg: (status == 'RO' ? your_ticket_reopened :
            your_ticket_resolved)
        });
      }
      else {
        this.setState({ open: false, openTicketSuccess: true, ticket_no: this.state.ticket_no, ticket_success_msg: (status == 'RO' ? 'Your ticket reopened failed!' : 'Your ticket resolved failed!') });

      }
    });
  }
  render() {
    const { t } = this.props
    const heading = (localStorage.pharmacy_language == 'ar') ? [
      { id: "", label: this.props.t("tbl_head_action") },
      /* { id: "response", label: this.props.t("tbl_head_Issue_addressed_by_tom") }, */
      { id: "status", label: this.props.t("support_time") },
      { id: "status", label: this.props.t("support_date") },
      { id: "status", label: this.props.t("tbl_head_status") },
      /*  { id: "remarks", label: this.props.t("tbl_head_issue_raised_by_vendor") }, */
      { id: "screen_name", label: this.props.t("tbl_head_screen_name") },
      { id: "ticket_id", label: this.props.t("tbl_head_ticket_id") },
      { id: "", label: this.props.t("tbl_head_s_no") },
    ] : [
      { id: "", label: this.props.t("tbl_head_s_no") },
      { id: "ticket_id", label: this.props.t("tbl_head_ticket_id") },
      { id: "screen_name", label: this.props.t("tbl_head_screen_name") },
      /*  { id: "remarks", label: this.props.t("tbl_head_issue_raised_by_vendor") }, */
      { id: "status", label: this.props.t("tbl_head_status") },
      { id: "status", label: this.props.t("support_date") },
      { id: "status", label: this.props.t("support_time") },
      /* { id: "response", label: this.props.t("tbl_head_Issue_addressed_by_tom") }, */
      { id: "", label: this.props.t("tbl_head_action") },
    ]

    return (
      <div>
        <div className="uploadsmasterheader ticketing_head_div">
          <div className="title_head" style={{ textTransform: 'uppercase' }}>{t('ticketing')}</div>

          <div className="current_container">
            <img
              className="plus-icon"
              src={plus}
              alt={"hi"}
              style={{ width: 35, height: 35, cursor: "pointer" }}
              onClick={() => { this.handleClickopen() }}
            />
          </div>
        </div>
        <div className="ticket_table_div">
          <Tablecomponent
            heading={heading}
            rowdata={this.state.tabledata}
            modelopen={(e, id) => this.modelopen(e, id)}
            ShowTicketButton="true"
            EditIcon={"close"}
            DeleteIcon={"close"}
            props_loading={this.state.props_loading}
            t={t}
            i18n={this.props.i18n}
          />
        </div>

        <Modalcomp
          visible={this.state.open}
          xswidth={"xs"}
          title={t('add_ticket')}
          clrchange="text_clr_change text_color"
          closemodal={(e) => this.handleClickclose(e)}
          t={t}
          i18n={this.props.i18n}
        >
          {<TicketModal
            className="manage-modal"
            open={this.state.open}
            closemodal={this.handleClickclose}
            getTableData={this.getTableData}
            ticketSuccess={this.ticketSuccess}
            t={t}
            i18n={this.props.i18n}
          />}
        </Modalcomp>

        <Modalcomp
          visible={this.state.open_ticket_view}
          xswidth={"lg"}
          title={t('view_ticket')}
          clrchange="text_clr_change text_color"
          closemodal={(e) => this.handleTicketViewClose(e)}
          t={t}
          i18n={this.props.i18n}
        >
          {<TicketView
            className="manage-modal"
            closemodal={this.handleTicketViewClose}
            {...this.state}
            t={t}
            i18n={this.props.i18n}
          />}
        </Modalcomp>



        <Dialog
          className='Dialogmodal ticket_table_success'
          // onClose={this.handleClose}
          open={this.state.openTicketSuccess}
          aria-labelledby="customized-dialog-title"
          maxWidth={"sm"}
          fullWidth={true}
          disableBackdropClick={true}
        >
          <div>
            <div style={{ marginTop: '3rem', textAlign: 'center' }}>
              <img src={TickMark} className="success_tick_mark" />
            </div>
            <div className="ticket_success_head" style={{ marginTop: '1rem', textAlign: 'center', marginBottom: '1rem', fontSize: '20px', color: 'var(--app-theme)' }}>{t("succes")}</div>
            <div style={{ marginTop: '1rem', textAlign: 'center', fontSize: '16px', color: 'black' }}> {this.state.ticket_success_msg}</div>
            {localStorage.pharmacy_language == 'ar' ? (<div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '1rem', color: 'black' }}>.{this.state.ticket_no} {t("your_ticket_id_is")} </div>) : (
              <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '1rem', color: 'black' }}> {t("your_ticket_id_is")} {this.state.ticket_no}.</div>
            )}
            {/* <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '1rem', color: 'black' }}> {t("your_ticket_id_is")} {this.state.ticket_no}.</div> */}
            <div className="contract_approve_btn_div" style={{ marginBottom: '1rem' }}>
              <Button className="ticketSubmit" onClick={() => { this.handleCloseSuccess() }}> {t("ok")} </Button>
            </div>


          </div>
        </Dialog>


      </div>
    );
  }
}

export default TicketTable;
